import React from 'react';
import styled, { css } from 'styled-components';

import { Row } from '../../global/grid/grid';
import colors from '../../../vars/colors';
import gutters from '../../../vars/gutters';
import breakpoints from '../../../vars/breakpoints';

export const InProgressWrapper = styled(Row)`
    .inProgressItem {
        &:last-child {
            margin-top: 200px;
            @media (max-width: ${breakpoints['bp-mobile']}) {
                margin-top: inherit;
            }
        }
        .city {
            font-family: 'OneDotExt', sans-serif;
            font-size: 38px;
            font-weight: bold;
            color: ${colors['black']};
            opacity: 0.8;
            text-transform: uppercase;
            margin-bottom: 5px;
            @media (max-width: ${breakpoints['bp-mobile']}) {
                font-size: 30px;
            }
        }
        .state {
            font-family: 'OneDot', sans-serif;
            font-size: 25px;
            letter-spacing: 2.9px;
            font-weight: bold;
            color: ${colors['black']};
            opacity: 0.8;
            text-transform: uppercase;
            margin-bottom: 30px;
            @media (max-width: ${breakpoints['bp-mobile']}) {
                font-size: 16px;
            }
        }
        &:hover {
            .stripes {
                animation-play-state: paused;
            }
        }
    }
    .initialsHolder {
        font-family: 'OneDotCd', sans-serif;
        font-weight: bold;
        color: ${colors['white-two']};
        position: absolute;
        right: 10%;
        top: -140px;
        width: 100%;
        font-size: 250px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        letter-spacing: 10px;
        z-index: -1;
        text-transform: uppercase;
        @media (max-width: ${breakpoints['bp-tablet']}) {
            transform: scale(0.8);
        }
        @media (max-width: ${breakpoints['bp-mobile']}) {
            display: none;
        }
    }
    .whiteMask {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: white;
        opacity: 0.5;
    }
    .colorBlock {
        overflow: hidden;
        position: absolute;
        z-index: -1;
        width: 80%;        
        &.left {
            top: 55%;
            left: calc(${gutters['container-gutters-desktop-l']} * -0.8);
            bottom: calc(${gutters['container-gutters-desktop-l']} * -0.7);
            @media (max-width: ${breakpoints['bp-desktop']}) {
                left: calc(${gutters['container-gutters-desktop']} * -0.8);
                bottom: calc(${gutters['container-gutters-desktop']} * -0.7);
            }
            @media (max-width: ${breakpoints['bp-tablet']}) {
                left: calc(${gutters['container-gutters-tablet']} * -0.8);
                bottom: calc(${gutters['container-gutters-tablet']} * -0.7);
            }
            @media (max-width: ${breakpoints['bp-mobile']}) {
                left: calc(${gutters['container-gutters-mobile']} * -0.8);
                bottom: calc(${gutters['container-gutters-mobile']} * -0.7);
            }
        }
        &.right {
            top: 55%;
            right: calc(${gutters['container-gutters-desktop-l']} * -0.8);
            bottom: calc(${gutters['container-gutters-desktop-l']} * -0.7);
            @media (max-width: ${breakpoints['bp-desktop']}) {
                right: calc(${gutters['container-gutters-desktop']} * -0.8);
                bottom: calc(${gutters['container-gutters-desktop']} * -0.7);
            }
            @media (max-width: ${breakpoints['bp-tablet']}) {
                right: calc(${gutters['container-gutters-tablet']} * -0.8);
                bottom: calc(${gutters['container-gutters-tablet']} * -0.7);
            }
            @media (max-width: ${breakpoints['bp-mobile']}) {
                right: calc(${gutters['container-gutters-mobile']} * -0.8);
                bottom: calc(${gutters['container-gutters-mobile']} * -0.7);
            }
        }
        .stripes {
            background: repeating-linear-gradient(-45deg, ${colors['faint-grey']}, ${colors['faint-grey']} 25px, rgba(255, 255, 255, 0.5) 25px, rgba(255, 255, 255, 0.5) 50px);
            position: absolute;
            top: -75px;
            left: -75px;
            right: -75px;
            bottom: -75px;            
            animation-name: barbersPole;
            animation-timing-function: linear;
            animation-iteration-count: infinite;
            animation-duration: 1200ms;
            animation-play-state: running;
            @keyframes barbersPole {
                0% {transform: translate3d(0, 0, 0)}
                100% {transform: translate3d(0, 72px, 0)}
            }
        }
    }
`;

export const Title = styled.div`
    display: inline-block;
    font-family: 'OneDot';
    font-size: 25px;
    font-weight: bold;
    line-height: 1.4;
    letter-spacing: 3px;
    text-align: center;
    text-transform: uppercase;
    color: ${colors['peacock-blue']};
    border-bottom: solid 15px ${colors['white-two']};
    margin-bottom: 100px;
    .carrot {
        margin-left: 5px;
        display: inline-block;
        height: 15px;
        width: 15px;
        box-sizing: border-box;
        transform-origin: center center;
        border-bottom: 5px solid ${colors['peacock-blue']};
        border-left: 5px solid ${colors['peacock-blue']};
        border-radius: 2px;
        transform: translate(0, -5px) rotate(-45deg);
    }
`;


// WEBPACK FOOTER //
// ./src/components/modules/InProgress/styled-components.js